// Configurações do Discord Activity
export const DISCORD_CONFIG = {
  // Substitua pelo seu Client ID do Discord Developer Portal
  clientId: '1458614248824635506',
  
  // Configurações da aplicação
  appName: 'Virtuplace',
  
  // Configurações de sincronização
  syncInterval: 100, // ms entre atualizações
};

// Configurações da cena 3D
export const SCENE_CONFIG = {
  // Cor de fundo
  backgroundColor: 0x1a1a2e,
  
  // Configurações da câmera
  camera: {
    fov: 75,
    near: 0.1,
    far: 1000,
    position: { x: 0, y: 5, z: 10 }
  },
  
  // Configurações de luz
  lighting: {
    ambient: { color: 0x404040, intensity: 0.5 },
    directional: { color: 0xffffff, intensity: 1, position: { x: 5, y: 10, z: 5 } }
  }
};

// Configurações dos jogadores
export const PLAYER_CONFIG = {
  // Tamanho do quadrado
  size: 1,
  
  // Velocidade de movimento
  speed: 0.1,
  
  // Cor padrão
  defaultColor: 0x4CAF50,
  
  // Cores aleatórias para diferentes usuários
  colors: [
    0x4CAF50, // Verde
    0x2196F3, // Azul
    0xFF9800, // Laranja
    0xE91E63, // Rosa
    0x9C27B0, // Roxo
    0xFFEB3B, // Amarelo
    0x00BCD4, // Ciano
    0xFF5722  // Vermelho
  ],
  
  // Configurações do texto (nome)
  nameTag: {
    fontSize: 32,
    fontFamily: 'Arial',
    color: '#ffffff',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: 10,
    height: 0.8 // Altura acima do quadrado
  }
};
